import styled from "vue-styled-components";

export const SWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  max-height: 500px;
`;

export const SHeader = styled.header`
  padding: 24px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray1} svg {
    cursor: pointer;
  }
`;

export const SHeaderTitle = styled.h4`
  margin: 0;
  font-family: ${({ theme }) => theme.font.family.inter};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.xl};
  color: #343a40;
`;

export const SSummary = styled.section`
  padding: 24px 8px;
  display: flex;
  gap: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray1};
`;

export const SSummaryItem = styled.div`
  padding-right: 32px;

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.neutral.gray1};
  }

  span {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.sm};
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }

  h6 {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.semiBold};
    font-size: ${({ theme }) => theme.font.size.md};
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }
`;

export const SDoctorsList = styled.ul`
  padding: 24px 8px;
  margin: 0;
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(285px, 1fr));
`;

export const SDoctorsListItem = styled.li`
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
`;

export const SDoctorCard = styled.article`
  height: 100%;
  padding: 16px 20px;
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray2};
  border-radius: 16px;
`;

export const SDoctorCardHeader = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

export const SDoctorCardHeaderInfo = styled.div`
  h6 {
    margin: 2px 0;
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.semiBold};
    font-size: ${({ theme }) => theme.font.size.md};
    letter-spacing: -0.5px;
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }

  small {
    margin: 2px 0;
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.sm};
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }
`;

export const SDoctorCardActions = styled.div`
  display: flex;
  align-items: center;
`;

export const SDoctorPrice = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.font.family.inter};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.sm};
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.colors.brand.green};
`;

export const SFooter = styled.footer`
  margin-top: auto;
  padding: 8px;
  p {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: ${({ theme }) => theme.font.size.sm};
    color: ${({ theme }) => theme.colors.neutral.gray7};
  }
`;

export const SCentered = styled.div`
  margin: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SEmptyState = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h2 {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.xl2};
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }

  p {
    max-width: 320px;
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.md};
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }
`;
